import { useEffect, useState } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { Home, Store, Package, User } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { supabase } from '@/integrations/supabase/client';

type Tab = { to: string; label: string; icon: React.ElementType; match?: (p: string) => boolean };

export function MobileBottomNav() {
  const { pathname } = useLocation();
  const { session } = useAuth();
  const [isSeller, setIsSeller] = useState(false);

  useEffect(() => {
    if (!session?.user?.id) { setIsSeller(false); return; }
    supabase.from('seller_profiles').select('is_active').eq('user_id', session.user.id).maybeSingle()
      .then(({ data }) => setIsSeller(!!data?.is_active));
  }, [session?.user?.id]);

  const tabs: Tab[] = [
    { to: '/dashboard', label: 'Home', icon: Home, match: (p) => p === '/dashboard' },
    { to: '/settings/basket', label: 'Basket', icon: Store, match: (p) => p.startsWith('/settings/basket') || p.startsWith('/baskets') },
    { to: '/orders', label: 'Orders', icon: Package, match: (p) => p.startsWith('/orders') || p.startsWith('/my-orders') },
    { to: '/settings/profile', label: 'Profile', icon: User, match: (p) => p.startsWith('/settings') && !p.startsWith('/settings/basket') },
  ];

  return (
    <nav
      className="fixed bottom-0 inset-x-0 z-30 bg-card/95 backdrop-blur-xl border-t border-border/60 md:hidden shadow-[0_-4px_20px_-8px_rgba(0,0,0,0.08)]"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
    >
      <ul className="flex items-stretch justify-around px-2 pt-2 pb-1">
        {tabs.map((t) => {
          const active = t.match ? t.match(pathname) : pathname === t.to;
          const Icon = t.icon;
          return (
            <li key={t.label} className="flex-1">
              <NavLink
                to={t.to}
                className="flex flex-col items-center justify-center gap-1 py-1.5"
              >
                <span
                  className={`grid place-items-center h-9 w-14 rounded-full transition-all ${
                    active ? 'bg-primary/10 text-primary' : 'text-muted-foreground'
                  }`}
                >
                  <Icon className={`h-5 w-5 ${active ? 'scale-110' : ''} transition-transform`} />
                </span>
                <span className={`text-[10px] font-semibold tracking-tight ${active ? 'text-primary' : 'text-muted-foreground'}`}>
                  {t.label}
                </span>
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
